export var getColumnOfRegion = function (wholeMixRegion, region) { return function () {
    var indexToColumnPosition = {
        0: 'left',
        1: 'right',
    };
    var columnIndex = wholeMixRegion.data.layout.rows[0].columns.reduce(function (resultingIndex, column, index) {
        if (column.regionIds.includes(region.regionId)) {
            return index;
        }
        return resultingIndex;
    }, 0);
    return indexToColumnPosition[columnIndex];
}; };
var MAX_GAP_WIDTH_BY_COLUMN_COUNT = {
    2: 60,
    3: 40,
    4: 30,
};
export var balanceGapsBetweenColumns = function (leftColumnPadding, rightColumnPadding, numberOfColumns) {
    var totalGap = parseInt(leftColumnPadding, 10) + parseInt(rightColumnPadding, 10);
    var finalGap = Math.min(totalGap, MAX_GAP_WIDTH_BY_COLUMN_COUNT[numberOfColumns]);
    var paddingRemainder = (finalGap || 0) % 2;
    var _a = [
        Math.floor(finalGap / 2) + paddingRemainder,
        Math.floor(finalGap / 2),
    ], right = _a[0], left = _a[1];
    return { right: right, left: left };
};
export var calculateColumnDesktopDisplayWidth = function (_a) {
    var columns = _a.columns, messageContentWidth = _a.messageContentWidth, outerPadding = _a.outerPadding, innerPadding = _a.innerPadding, leftColumnPadding = _a.leftColumnPadding, rightColumnPadding = _a.rightColumnPadding, isRtl = _a.isRtl;
    var leftoverWidth = 100 - columns.reduce(function (acc, curr) { return (acc = acc + curr.width); }, 0);
    var numberOfColumns = columns.length;
    var availableSpace = messageContentWidth - (outerPadding.left + outerPadding.right);
    var innerSpaceAfterAlignment = availableSpace - (innerPadding.right + innerPadding.left);
    var parsedLeftColumnPadding = parseInt(leftColumnPadding, 10);
    var parsedRightColumnPadding = parseInt(rightColumnPadding, 10);
    var paddingSpace = (numberOfColumns - 2) *
        (parsedLeftColumnPadding + parsedRightColumnPadding) +
        parsedLeftColumnPadding +
        parsedLeftColumnPadding;
    var contentSpace = innerSpaceAfterAlignment - paddingSpace;
    return columns.map(function (column, idx, all) {
        var spaceForColumn = contentSpace * ((column.width || 50) / 100);
        var firstColumnPadding = isRtl ? innerPadding.right : innerPadding.left;
        var lastColumnPadding = isRtl ? innerPadding.left : innerPadding.right;
        if (idx === 0) {
            return {
                width: column.width,
                displayWidth: ((spaceForColumn + firstColumnPadding + parsedLeftColumnPadding) *
                    100) /
                    availableSpace + "%",
            };
        }
        else if (idx === all.length - 1) {
            return {
                width: column.width,
                displayWidth: ((spaceForColumn + lastColumnPadding + parsedRightColumnPadding) *
                    100) /
                    availableSpace + "%",
            };
        }
        else {
            return {
                width: column.width,
                displayWidth: ((spaceForColumn +
                    (contentSpace / 100) * leftoverWidth +
                    parsedLeftColumnPadding +
                    parsedRightColumnPadding) *
                    100) /
                    availableSpace + "%",
            };
        }
    });
};
//# sourceMappingURL=utils.js.map